import { FC } from 'react'
import { Chip } from '@mui/material'
import type { PublicacaoPoliticaFinanceiro } from '@/types/comissao'

/**
 * Selo da publicação em duas pessoas (V64, AN-PP6 §3/§8) nas políticas do Financeiro (NF e retenção): PENDENTE,
 * REJEITADA ou LEGADO (ATIVA anterior à dupla aprovação). ATIVA aprovada normal não ganha selo. Só lê o
 * `statusPublicacao`/`legado` do backend.
 */
export const SeloPublicacao: FC<{ politica: PublicacaoPoliticaFinanceiro }> = ({ politica }) => {
  if (politica.statusPublicacao === 'PENDENTE_APROVACAO') {
    return <Chip size="small" color="warning" label="pendente de aprovação" sx={{ ml: 0.5 }} />
  }
  if (politica.statusPublicacao === 'REJEITADA') {
    return <Chip size="small" color="error" variant="outlined" label="rejeitada" sx={{ ml: 0.5 }} />
  }
  if (politica.legado) {
    return (
      <Chip
        size="small"
        variant="outlined"
        label="legado"
        title="Anterior à dupla aprovação"
        sx={{ ml: 0.5 }}
      />
    )
  }
  return null
}

export default SeloPublicacao
